<div class="dynamic-field form-input" [formGroup]="group">
    <label>{{ config.label }}</label>
    <div *ngIf="config.info" class="field-info">{{ config.info }}</div>
    <textarea
        [froalaEditor]="options"
        [formControlName]="getControlName(config)"
        [(froalaModel)]="config.value"
    ></textarea>
</div>
